module.exports = __webpack_public_path__ + "static/img/disease-baby.e293d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/monogenicdisease/disease-baby.jpg
// module id = 0nLj
// module chunks = 0